import API from "../utils/api";

// 🟢 CREATE PRODUCT BATCH
const createProductBatch = async (formData) => {
  const response = await API.post("/api/product-batches", formData);
  console.log("createProductBatch response:", response.data);
  return response.data;
};

// 🔵 GET ALL PRODUCT BATCHES
const getProductBatches = async (productId = null) => {
  const query = productId ? `?product=${productId}` : "";
  const response = await API.get(`/api/product-batches${query}`);
  console.log("getProductBatches response:", response.data);
  return response.data;
};

// 🟡 GET SINGLE PRODUCT BATCH
const getSingleProductBatch = async (id) => {
  const response = await API.get(`/api/product-batches/${id}`);
  return response.data;
};

// 🟠 UPDATE PRODUCT BATCH
const updateProductBatch = async (id, formData) => {
  const response = await API.put(`/api/product-batches/${id}`, formData);
  return response.data;
};

// 🔴 DELETE PRODUCT BATCH
const deleteProductBatch = async (id) => {
  const response = await API.delete(`/api/product-batches/${id}`);
  return response.data;
};

// 🟢 GET CUMULATIVE PRODUCT BATCHES WITH STOCK VALUE
const getCumulativeProductBatches = async () => {
  const response = await API.get("/api/product-batches/cumulative");
  return response.data;
};


const productBatchService = {
  createProductBatch,
  getProductBatches,
  getSingleProductBatch,
  updateProductBatch,
  deleteProductBatch,
  getCumulativeProductBatches,
};

export default productBatchService;